import { TLoadComgateCheckoutConfig } from '../../types';
import { baseConfigValidator } from '../baseConfigValidator';

/**
 * Check Comgate Checkout loading configuration
 * @param config
 */
export function preloadConfigValidator(config: TLoadComgateCheckoutConfig): string | true {
    const validResponse = baseConfigValidator(config);

    if (validResponse !== true) {
        return validResponse;
    }

    return true;
}
